enum PaymentTypesEnum {
    CREDIT_CARD = 1,
    CASH = 2,
    CHECK = 3,
    TERMS = 4,
    SALES_REP = 5,
}

export default PaymentTypesEnum;
